/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { compareQtrs } from '../../../SharedModules/CommonUtilities/commonUtilities';
import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import { quarterComparator } from '../../../SharedModules/DateUtilities/DateUtilities';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr } from '../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

export const columnDefs = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellClass: 'frr-ellipsis-text',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rebateColumnDef = [
  {
    headerName: 'Rebate Program Code',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractColumnDef = [
  {
    headerName: 'Contract Num',
    field: 'contractSeqNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Name',
    field: 'name',
    editable: false,
    sortable: true,
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebatePgm',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const arSummaryColumns = [
  {
    headerName: 'Actions',
    field: 'actions',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'actionRenderer',
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-custom-icon-padding',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    cellClassRules: {
      'd-none': (params) => params.data?.actions === 'hide',
    },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    cellClass: 'frr-ellipsis-text',
    minWidth: Styles.Width_250,
    cellRenderer: 'FullNameRender',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Sum Invoice Balance',
    field: 'sumInvoiceBalance',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'redTextRenderer',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Sum Offset Due',
    field: 'offsetDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Base State Amount Due',
    field: 'baseStateAmountDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Unallocatted Due',
    field: 'unAllocatedBalance',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Balance',
    field: 'totalBalance',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Disputed Amount',
    field: 'disputesAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Interest Due',
    field: 'interestDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellRenderer: 'redTextRenderer',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const ARManufacturerColumns = [
  {
    headerName: 'Actions',
    field: 'cc_COMMENTS_EXIST',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionRenderer',
    cellEditor: MaxLengthNumericEditor,
    showCheckboxIcon: true,
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-custom-icon-padding frr-action-ndcdetail',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'd-none': (params) => params.data?.actions === 'hide',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    cellRenderer: 'InvoiceDateRender',
    comparator: comparatorQtr,

    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Invoice Status',
    field: 'invoiceStatus',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Invoice Handling',
    field: 'invoiceHandling',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Invoice Date',
    field: 'invoiceDate',
    editable: false,
    sortable: true,
    suppressMenu: false,
    comparator: dateComparator,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'InvoiceDateRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'origInvoiceAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Principal Due',
    field: 'currBalDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Offset Due',
    field: 'offsetDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Base State Amount Due',
    field: 'baseStateAmountDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportZeroesTwo: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'currInvAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Current Rebate Offset Amount',
    field: 'currRoa',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Base State Rebate Amount',
    field: 'baseStateRebateAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'amtPaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Offset Paid Amount',
    field: 'offsetPaidAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Base State Amount Paid',
    field: 'baseStateAmountPaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    exportZeroesTwo: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'interestPaidAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Disputed Amount',
    field: 'disputedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Unpaid Amount',
    field: 'unpaidAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    exportZeroesTwo: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Adjustment Amount',
    field: 'adjustmentAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Unit Change Amount',
    field: 'unitChangeAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Family Planning Amount',
    field: 'famPlnAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Federal Amount',
    field: 'fedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    dataAlignRight: true,
    isTextColorRed: true,
    exportZeroesTwo: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'State Amount',
    field: 'stateAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'redTextRenderer',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
  {
    headerName: 'Collection Letter Sent',
    field: 'ccLetterSent',
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    showCheckboxIcon: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'CheckboxRenderer',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatus === 'DB' ||
        params.data?.invoiceStatus === 'FG' ||
        params.data?.invoiceStatus === 'WO' ||
        params.data?.invoiceStatus === 'DBK',
      'd-none': (params) => params.data?.actions === 'hide',
      'yellow-legend': (params) =>
        params.data?.drams &&
        params.data?.qtr &&
        compareQtrs(params.data?.drams, params.data?.qtr),
    },
  },
];

export const ARSummryByQtrColumns = [
  {
    headerName: 'Actions',
    field: 'actions',
    hideFilterIcon: true,
    cellRenderer: 'ActionCellRender',
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-custom-icon-padding',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'd-none': (params) => params.data?.actions === 'hide',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Quarter',
    field: 'quarter',
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    comparator: comparatorQtr,
    cellRenderer: 'NameTextRender',
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Principal Due',
    field: 'currBalance',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    exportZeroesTwo: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Offset Due',
    field: 'offsetDue',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Amount Due',
    field: 'baseStateAmountDue',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Total Due',
    field: 'totalDue',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'amtPaid',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    columnSpan: 2,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Offset Paid Amount',
    field: 'offsetPaidAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Paid Amount',
    field: 'baseStatePaidAmount',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    columnSpan: 2,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Interest Paid',
    field: 'interestPaid',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'currInvAMt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Rebate Offset Amount',
    field: 'currRoa',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Rebate Amount 2',
    field: 'baseStateRebateAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'origInvAMt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Invoices',
    field: 'invoices',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Open Disputes',
    field: 'disputeCount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Disputed Amount',
    field: 'disputeAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Claim Paid Amount',
    field: 'revisedReimburseAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
];

export const accountReceivableNDCActivityColumns = [
  {
    headerName: 'Comments Exists',
    cellRenderer: 'ActionCellRender',
    field: 'cc_COMMENTS_EXIST',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    showCheckboxIcon: true,
    cellClass: 'frr-custom-icon-padding frr-action-ndcdetail',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
  },
  {
    headerName: 'Activity Type',
    field: 'activityType',
    cellRenderer: 'ActivityCellRenderer',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Invoice Qtr',
    field: 'invoiceQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    comparator: quarterComparator,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity Date',
    field: 'activityDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    sortable: true,
    comparator: dateComparator,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity URA',
    field: 'acivityURA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA Change',
    field: 'uraChange',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity Units',
    field: 'activityUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,

    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units Change',
    field: 'unitChange',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellRenderer: 'redTextWithoutDollar',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity UROA',
    field: 'unitRebateOffsetAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'ROA Change Amount',
    field: 'roaChangeAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_220,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Resolution',
    field: 'disputeResolutionInd',
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    showCheckboxIcon: true,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'center' },
    filter: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Units',
    field: 'paidUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Code',
    field: 'disputeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number Of Claims',
    field: 'numberClaims',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursement Amount',
    field: 'reimburseAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Activity Claim Count',
    field: 'activityClaimCount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Overridden Change Amount',
    field: 'overridenChangeAmount',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Overridden ROA Change Amount',
    field: 'overridenRoaChangeAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_280,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Change Amount',
    field: 'totChangeAmt',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Update Date',
    field: 'updateDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'User Id',
    field: 'userId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const QtrAccRecColumns = [
  {
    headerName: 'Actions',
    field: 'actions',
    hideFilterIcon: true,
    cellRenderer: 'ActionCellRender',
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellClass: 'frr-custom-icon-padding',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: false,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
      'd-none': (params) => params.data?.actions === 'hide',
    },
  },
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    cellRenderer: 'FullNameRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Invoice Status',
    field: 'invoiceStatusCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Invoice Date',
    field: 'invoiceDate',
    // cellRenderer: 'invoiceDateRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Principal Due',
    field: 'currBal',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    exportZeroesTwo: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Offset Due',
    field: 'offsetDue',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Amount Due',
    field: 'baseStateAmtDue',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Total Due',
    field: 'totalDue',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'amtPaid',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Offset Paid Amount',
    field: 'offsetPaidAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Paid Amount',
    field: 'baseStatePaidAmount',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'interestPaid',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'currInvAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Rebate Offset Amount',
    field: 'currentRoa',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Base State Rebate Amount',
    field: 'baseStateRebateAmount',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'origInvoiceAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Adjustment Amount',
    field: 'adjustmentAmount',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Open Disputes',
    field: 'disputeCount',
    // cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'left' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Dispute Amount',
    field: 'disputeAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isTextColorRed: true,
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Current Claim Paid Amount',
    field: 'reimbAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Family Planning Amount',
    field: 'famPlanAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'Federal Amount',
    field: 'fedAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },

    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
  {
    headerName: 'State Amount',
    field: 'stateAmt',
    cellRenderer: 'RedTextRender',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.invoiceStatusCd === 'DB' ||
        params.data?.invoiceStatusCd === 'FG' ||
        params.data?.invoiceStatusCd === 'WO',
      'yellow-legend': (params) => params.data?.convertedQtrInd === 1,
    },
  },
];

export const accountReceivableNDCDetailColumns = [
  {
    headerName: 'Actions',
    field: 'commentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    hideFilterIcon: true,
    resizable: true,
    editable: false,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellRenderer: 'ActionRenderer',
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-custom-icon-padding frr-action-ndcdetail',
    cellStyle: { borderRightColor: Styles.BorderColor },
    fillBackgroundColorCol: 'bgHighlighterColor',
    showBackgroundColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.actions === 'hide',
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'FullNameRender',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Status',
    field: 'status',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NameTextRender',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original Invoice Amount',
    field: 'originalInvoiceAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current Invoice Amount',
    field: 'currentInvoiceAmount',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    exportZeroesTwo: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current Rebate Offset Amount',
    field: 'currentRebateOffsetAmount',
    cellRenderer: 'redTextRenderer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_270,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Base State Rebate Amount',
    field: 'baseStateRebateAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'principalPaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Offset Paid Amount',
    field: 'offsetPaidAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Base State Paid Amount',
    field: 'baseStatePaidAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Principal Due',
    field: 'principalDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Offset Due',
    field: 'offsetDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Base State Amount Due',
    field: 'baseStateAmountDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Interest Calculated',
    field: 'interestCalculated',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'interestPaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Total Due',
    field: 'totalAmountDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original Units',
    field: 'originalUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NegativeRed',
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    exportZeroesThree: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.originalUnits === '',
    },
  },
  {
    headerName: 'Current Units',
    field: 'currentUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NegativeRed',
    exportZeroesThree: true,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.currentUnits === '',
    },
  },
  {
    headerName: 'Units Paid',
    field: 'unitsPaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NegativeRed',
    exportZeroesThree: true,

    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.unitsPaid === '',
    },
  },
  {
    headerName: 'Units Unpaid',
    field: 'unitsUnpaid',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NegativeRed',
    exportZeroesThree: true,

    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.unitsUnpaid === '',
    },
  },
  {
    headerName: 'Units Disputed',
    field: 'unitsDisputed',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_167,
    cellRenderer: 'NegativeRed',
    exportZeroesThree: true,

    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.unitsDisputed === '',
    },
  },
  {
    headerName: 'Disputed Amount',
    field: 'disputedAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original URA',
    field: 'originalURA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    exportZeroesFour: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.originalURA === '',
    },
  },
  {
    headerName: 'Current URA',
    field: 'currentURA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    exportZeroesFour: true,

    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.currentURA === '',
    },
  },
  {
    headerName: 'Most Recent URA',
    field: 'mostRecentURA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    exportZeroesFour: true,

    isTextColorRed: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Most Recent Quarter',
    field: 'mostRecentQuarter',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    isTextColorRed: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original UROA',
    field: 'originalUROA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    isTextColorRed: true,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current UROA',
    field: 'currentUROA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    isTextColorRed: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original Invoice Scripts',
    field: 'originalInvoiceScripts',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original Reimburse Amount on Claims',
    field: 'originalReimburseAmountOnClaims',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_320,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Original Other Payments From Claims',
    field: 'originalOtherpaymentsfromClaims',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_320,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current Scripts',
    field: 'currentScripts',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current Reimburse Amount on Claims',
    field: 'currentReimburseAmountOnClaims',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_320,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Current Other Payments From Claims',
    field: 'currentOtherPaymentsfromClaims',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_320,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'Family Planning Indicator',
    field: 'familyPlanningindicator',
    editable: false,
    sortable: false,
    suppressMenu: false,
    minWidth: Styles.Width_240,
    cellRenderer: 'CheckboxRenderer',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    showCheckboxIcon: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'center' },
    filter: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
      'd-none': (params) => params.data?.familyPlanningindicator === null,
    },
  },
  {
    headerName: 'Federal Amount',
    field: 'federalAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
  {
    headerName: 'State Amount',
    field: 'stateAmount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'redTextRenderer',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    exportZeroesTwo: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    bgColorName: 'bgHighlighterColor',
    isBgColor: true,
    cellClassRules: {
      'green-legend': (params) =>
        params.data?.status === 'DB' ||
        params.data?.status === 'FG' ||
        params.data?.status === 'WO' ||
        params.data?.status === 'DBK' ||
        params.data?.unitsModFromArInd === 1,
    },
  },
];
